import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AngularPhoneNumberInputComponent } from '../angular-phone-input/angular-phone-number-input.component';

@Component({
  selector: 'app-phone-component',
  templateUrl: './phone-component.component.html',
  styleUrl: './phone-component.component.scss'
})
export class PhoneComponentComponent {
  @ViewChild('phoneInput') phoneInput: AngularPhoneNumberInputComponent;
  @Input({ required: true }) control: FormControl;

  @Input({ required: false }) label?: string;
  @Input({ required: true }) placeholder: string;
  @Input({ required: true }) errorMessage: string;

  @Input({ required: false }) width = "30%";
  @Input({ required: false }) isResponsive = true;
  @Input({ required: false }) height = "auto";
  /** ISO 3166-1 alpha-2 (e.g. SA). Used to parse national numbers from the API without mis-detecting dial codes. */
  @Input({ required: false }) defaultCountryIso: string | null | undefined;

  canRender = false;

  isInvalid(): boolean {
    const control = this.control;
    return control ? control.invalid && (control.dirty || control.touched) : false;
  }

  constructor(private cdr: ChangeDetectorRef) { }

}
